// extracted by mini-css-extract-plugin
export var rounded = "rounded-Z3-";
export var video_container = "video_container-1dh";
export var video_thumbnail = "video_thumbnail-uW6";
export var video_thumbnail_play_button = "video_thumbnail_play_button-bDw";